import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/shadcn/dialog";
import { Sparkles } from "lucide-react";

interface ReasoningDialogProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  content: string;
}

const ReasoningDialog: React.FC<ReasoningDialogProps> = ({
  isOpen,
  onOpenChange,
  content,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[60%]! w-[60%] h-[80%] rounded-2xl shadow-2xl flex flex-col">
        <DialogHeader className="flex flex-row flex-shrink-0 items-center gap-2 h-fit">
          <Sparkles size={20} className="text-muted-foreground" />
          <DialogTitle>Prompt Improvement Reasoning</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto min-h-0 px-6">
          <div className="bg-muted p-6 rounded-md w-ful h-full overflow-y-auto">
            <pre className="whitespace-pre-wrap text-foreground text-sm font-mono">
              {content}
            </pre>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReasoningDialog;
